import moment from 'moment';
import type { DateRange, MonthDescriptor } from './types';

export function generateMonthsInRange(dateRange: DateRange): MonthDescriptor[] {
  const start = moment(dateRange.start).startOf('month');
  const end = moment(dateRange.end).startOf('month');

  if (!start.isValid() || !end.isValid() || end.isBefore(start)) {
    return [];
  }

  const months: MonthDescriptor[] = [];
  const current = start.clone();
  let index = 0;

  while (current.isSameOrBefore(end, 'month')) {
    months.push({
      key: current.format('YYYY-MM'),
      label: current.format('MMM YYYY'),
      shortLabel: current.format('MMM'),
      year: current.year(),
      month: current.month() + 1,
      daysInMonth: current.daysInMonth(),
      index
    });
    current.add(1, 'month');
    index += 1;
  }

  return months;
}
